"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeProtocol = (value, index) => {
    return !index
        ? value.replace(/^[a-zA-Z]+(:\/\/|%3A%2F%2F)/, "")
        : value;
};
exports.default = exports.removeProtocol;
//# sourceMappingURL=remove_protocol.js.map